<template>
  <button class="w3-left w3-button w3-black w3-margin" @click="exportToExcel()">
    <i class="fa fa-file-excel-o"></i>&nbsp;Export to Excel
  </button>
</template>

<script>
export default {
  name: "ExportToExcel",
  props: ["FieldNames", "FileName", "InputData", "MultiHeader", "Merges"],
  methods: {
    exportToExcel() {
      import("@/vendors/Export2Excel").then((excel) => {
        const list = this.InputData;
        const filterVal = Object.keys(list[0]);
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          multiHeader: this.MultiHeader,
          header: this.FieldNames,
          data,
          filename: this.FileName,
          autoWidth: true,
          merges: this.Merges,
          bookType: "xlsx",
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
  },
};
</script>

<style></style>
